import { render, staticRenderFns } from "./myrecord.vue?vue&type=template&id=ae6c12e8"
import script from "./myrecord.vue?vue&type=script&lang=js"
export * from "./myrecord.vue?vue&type=script&lang=js"
import style0 from "./myrecord.vue?vue&type=style&index=0&id=ae6c12e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports